import React, { FC } from 'react';
import { Box, Typography } from '@material-ui/core';
import MessageIcon from '@material-ui/icons/Message';
import useStyles from './styles';

const DiscussionUserEmpty: FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.wrapper}>
      <MessageIcon fontSize="large" />
      <Typography className={classes.title}>Liste des discussions</Typography>
      <Typography className={classes.subtitle}>
        Il n'y a aucune discussion pour l'instant.
      </Typography>
    </Box>
  );
};

export default DiscussionUserEmpty;
